import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import toast from 'react-hot-toast';
import { FaStar } from 'react-icons/fa';

const API = process.env.REACT_APP_API_URL;

const ReviewForm = ({ productId, onReviewAdded }) => {
  const [form, setForm] = useState({ name: '', rating: 5, comment: '' });
  const [hover, setHover] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/products/${productId}/reviews`, form);
      toast.success('Review submitted! 🙏');
      setForm({ name: '', rating: 5, comment: '' });
      onReviewAdded();
    } catch {
      toast.error('Could not submit review');
    }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%', padding: '0.8rem 1rem',
    background: '#fffdf5', border: '1px solid #e8c96d',
    borderRadius: '8px', fontFamily: 'Crimson Text',
    fontSize: '1rem', color: '#2C1810', outline: 'none',
    marginBottom: '1rem'
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      style={{
        background: 'linear-gradient(145deg, #fffdf5, #fdf0d0)',
        border: '1px solid #e8c96d', borderRadius: '16px', padding: '2rem', marginTop: '2rem'
      }}>
      <h3 style={{ fontFamily: 'Cinzel', color: '#2C1810', marginBottom: '1.5rem', fontSize: '1.1rem' }}>
        Share Your Experience 🙏
      </h3>
      <form onSubmit={handleSubmit}>
        <input style={inputStyle} placeholder="Your Name" value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })} required />

        {/* Star Rating */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '1rem' }}>
          {[1, 2, 3, 4, 5].map(star => (
            <FaStar key={star} size={28} style={{ cursor: 'pointer', transition: 'color 0.2s' }}
              color={(hover || form.rating) >= star ? '#D4AF37' : '#ddd'}
              onClick={() => setForm({ ...form, rating: star })}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(null)}
            />
          ))}
        </div>

        <textarea style={{ ...inputStyle, minHeight: '100px', resize: 'vertical' }}
          placeholder="Tell others about this product..."
          value={form.comment}
          onChange={e => setForm({ ...form, comment: e.target.value })} required />

        <motion.button whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
          type="submit" disabled={loading}
          style={{
            background: 'linear-gradient(135deg, #D4AF37, #FF6B00)',
            color: '#fff', border: 'none', padding: '0.8rem 2rem',
            borderRadius: '8px', fontFamily: 'Cinzel', fontSize: '0.9rem',
            letterSpacing: '2px', cursor: 'pointer', width: '100%'
          }}>
          {loading ? 'Submitting...' : 'SUBMIT REVIEW'}
        </motion.button>
      </form>
    </motion.div>
  );
};

export default ReviewForm;